import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React, { useState } from "react";
import { LAST_UPDATED } from "../util/constants.js";
import { getShiftDate } from "../util/dateTimeFormatter.js";
import {
  getAccessExceptionsEmployeeIdCustomComparator,
  getAccessExceptionsEmployeeNameCustomComparator,
  getAccessExceptionsIsRoleCustomComparator,
  getAccessExceptionsLastUpdatedCustomComparator
} from "../util/sortTrades.js";
import ActionButton from "./fundamentals/ActionButton.jsx";

const UserAccessOverrideEventTable = (props) => {
  const [sortModel, setSortModel] = useState([
    {
      field: "employeeName",
      sort: "asc",
    },
  ]);

  const renderEmployeeName = (overrideEvent) => {
    return overrideEvent.lastName + ", " + overrideEvent.firstName;
  };

  const renderAccessCheckbox = (isOn) => {
    return (
      <Checkbox disableRipple checked={isOn} color="primary" inputProps={{ "aria-label": "secondary checkbox" }} />
    );
  };

  const renderMultiStationAdminStationList = (overrideEvent) => {
    return overrideEvent.multiStationAdminStationList.map((station) => {
      return <Chip key={station} className="station-chip" label={station} />;
    });
  };

  const renderEdit = (overrideEdit) => {
    return (
      <ActionButton variant="outlined" color="primary" onClick={() => props.onOpenEditManageAccessDialog(overrideEdit)}>
        EDIT
      </ActionButton>
    );
  };

  const renderDesktopAccessOverrideEvents = () => {
    const columns = [
      {
        field: "edit",
        headerName: " ",
        type: "string",
        renderCell: (params) => {
          return renderEdit(params.row);
        },
        flex: 0.1,
        sortable: false,
      },
      {
        field: "createdAt",
        headerName: LAST_UPDATED,
        type: "dateTime",
        valueFormatter: (params) => {
          return getShiftDate(params.value);
        },
        flex: 0.11,
        sortComparator: getAccessExceptionsLastUpdatedCustomComparator,
      },
      {
        field: "employeeName",
        valueGetter: (params) => {
          return params.row;
        },
        renderCell: (params) => {
          return renderEmployeeName(params.row);
        },
        headerName: "Employee Name",
        type: "string",
        flex: 0.15,
        sortComparator: getAccessExceptionsEmployeeNameCustomComparator,
      },
      {
        field: "eid",
        headerName: "Employee ID",
        type: "string",
        flex: 0.12,
        sortComparator: getAccessExceptionsEmployeeIdCustomComparator,
      },
      {
        field: "isEmployee",
        renderCell: (params) => {
          return renderAccessCheckbox(params.row.isEmployee);
        },
        headerName: "Employee",
        type: "string",
        flex: 0.1,
        sortComparator: getAccessExceptionsIsRoleCustomComparator,
      },
      {
        field: "isAdmin",
        renderCell: (params) => {
          return renderAccessCheckbox(params.row.isAdmin);
        },
        headerName: "Station Admin",
        type: "string",
        flex: 0.12,
        sortComparator: getAccessExceptionsIsRoleCustomComparator,
      },
      {
        field: "isMultiStationAdmin",
        renderCell: (params) => {
          return renderAccessCheckbox(params.row.isMultiStationAdmin);
        },
        headerName: "Multi-Station Admin",
        type: "string",
        flex: 0.15,
        sortComparator: getAccessExceptionsIsRoleCustomComparator,
      },
      {
        field: "multiStationAdminStationList",
        renderCell: (params) => {
          return renderMultiStationAdminStationList(params.row);
        },
        headerName: "Stations",
        type: "string",
        flex: 0.2,
        sortable: false,
      },
    ];

    return (
      <div style={{ width: "100%", height: "inherit" }}>
        <DataGridPro
          rows={props.events}
          columns={columns}
          sortModel={sortModel}
          onSortModelChange={(event) => setSortModel(event)}
          sortingOrder={["asc", "desc"]}
          disableColumnMenu={true}
          hideFooterPagination={true}
          rowHeight={50}
          loading={props.isLoading}
          error={props.isError}
        />
      </div>
    );
  };

  return <div className="stars-table">{renderDesktopAccessOverrideEvents()}</div>;
};

export default UserAccessOverrideEventTable;
